import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Plan sheet provider toggle: the Apple segment's label.
export default class AppStoreText extends BaseOption {
  static userInterfaceComponent = {
    label: "App Store Label",
    component: inspectorTools.SIMPLE_INPUT,
  };

  static defaultValue = "Pay in App Store";
}
